const GA_MEASUREMENT_ID = 'G-F4LT90VZ8M';

export const pageview = (url) => {
    if (!window.gtag) return;

    window.gtag('config', GA_MEASUREMENT_ID, {
        page_path: url,
    });
};

export const event = ({ action, category, label, value }) => {
    if (!window.gtag) return;

    window.gtag('event', action, {
        event_category: category,
        event_label: label,
        value,
    });
};
